<div class="p-fluid">
  <kodit-field fieldLabel="Datum prometa" fieldLabelFor="dupliranje-datum-prometa">
    <kodit-calendar
      formCtrlId="dupliranje-datum-prometa"
      [formCtrl]="form.controls.datumPrometa"
      ctrlPlaceholder="Prema pravilu za datum prometa"
    ></kodit-calendar>
  </kodit-field>
  <kodit-field fieldLabel="Napomena" fieldLabelFor="dupliranje-napomena">
    <kodit-textarea-input
      formCtrlId="dupliranje-napomena"
      [formCtrl]="form.controls.napomena"
      ctrlPlaceholder="Ostavite prazno da se zadrži napomena sa originala"
    ></kodit-textarea-input>
  </kodit-field>
  <div class="p-d-flex p-flex-column">
    <span class="note">
      *** Biće kreirano {{ racunIds.length }} {{ vrstaRacunaLabel }} u statusu Nacrt, sa stavkama i cenama sa
      originala. Dobićete notifikaciju kada se dupliranje završi.
    </span>
  </div>
</div>
